import { type InsuranceCorporateIdentity } from "../types";

export function ErnstYoungLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_35_10136)">
        <path d="M445 64L68 201.61L445 134.969V64Z" fill="white" />
        <path
          d="M128.528 374.704H197.702V334.46H128.528V302.87H204.619L179.111 258.731H71.0264V449.567H223.642V405.861H128.528V374.704ZM325.242 259.164L292.816 321.478L260.391 259.164H197.269L263.85 374.704V450H320.919V374.704L387.499 259.164H325.242Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_35_10136">
          <rect
            width="377"
            height="386"
            fill="white"
            transform="translate(68 64)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export const ErnstYoung: InsuranceCorporateIdentity = {
  id: "ernst-young",
  name: "Ernst & Young BKK",
  logo: ErnstYoungLogo,
  backgroundColor: "#FFD500",
  textColor: "#000000",
  wildcard: "ernst",
  type: "statutory",
};
